import styled from 'styled-components';
import type { TermsAndConditionsPageQuery } from '@graphql/pages/terms-and-conditions.generated';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import { StyledHtmlRenderer } from '../shared/StyledHtmlRenderer';

type Props = { termsAndConditionsPageData: TermsAndConditionsPageQuery['termsAndConditions'] };

const PageTitleH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  text-transform: uppercase;
  margin-top: ${(p) => p.theme.unit(8)};
  margin-bottom: ${(p) => p.theme.unit(4)};
`;

const PageBodyDiv = styled(StyledHtmlRenderer)`
  margin-bottom: ${(p) => p.theme.unit(11)}
`;

const TermsAndConditionsContent = (props: Props) => {
  const {
    termsAndConditionsPageData,
  } = props;

  const displayName = termsAndConditionsPageData?.displayName ?? 'Terms and Conditions';
  const pageBody = termsAndConditionsPageData?.pageBody || '';

  const pageBodyRender = (
    <PageBodyDiv dangerouslySetInnerHTML={{
      __html: pageBody,
    }}
    />
  );

  return (
    <MaxWidthLayout>
      <PageTitleH1>
        {displayName}
      </PageTitleH1>
      {pageBodyRender}
    </MaxWidthLayout>
  );
};

export default TermsAndConditionsContent;
